import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EnumLocalizePipe } from 'sc-common/shared/pipes/enum-localize.pipe';
import { EnumStylePipe } from 'sc-common/shared/pipes/enum-style.pipe';
import { OverflowTooltipDirective } from 'sc-common/shared/tooltip/tooltip.directive';

@Component({
    selector: 'sc-external-enum-tag',
    templateUrl: './enum-tag.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EnumStylePipe, EnumLocalizePipe, UpperCasePipe, OverflowTooltipDirective]
})
export class ExternalEnumTagComponent {

    @Input()
    public enumType: any;

    @Input()
    public enumValue: any;
}
